<script>
	export default {
		name: 'ValidationExecuter',
		methods: {
			getValidationRules(rules) {
				const self_ = this;

				if(self_.isEmpty(rules)) { return '' }

				let result_ = '';
				let first_ = true;

				Object.keys(rules).forEach(key => {
					if(key == 'min' || key == 'max') {
						if(!self_.isFalse(rules[key])) {
							if(!first_) { result_ += '|' }
							result_ += key + ':' + rules[key]
							first_ = false;
						}
					} else {
						if(rules[key]) {
							if(!first_) { result_ += '|' }
							result_ += key;
							first_ = false;
						}
					}
				})

				return result_
			}
		}
	}
</script>